const readPersistedUser = () => {
  try {
    const raw = localStorage.getItem("USER_PROFILE");
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (err) {
    return {};
  }
};

export default {
  loggedIn: Boolean(readPersistedUser()._id),
  user: readPersistedUser(),
  token: localStorage.getItem("USER_TOKEN") || "",
  indicators: {
    totalItems: 0,
    unassignedItems: 0,
    assignedItems: 0,
    soldItems: 0,
    orderPaymentPendingItems: 0
  },
}